import { useMutation } from 'react-query'
import { get, postAPI } from 'framework/api/http'

interface GetInboundShipmentListInterface {
  etaDateFrom?: string | null
  etaDateTo?: string | null
  orderDateFrom?: string | null
  orderDateTo?: string | null
  receiptedDateFrom?: string | null
  receiptedDateTo?: string | null
  search?: string
  skip?: number
  status?: string
  take?: number
  warehouse?: string
}

export const useGetInboundShipmentList = () => {
  const mutate = useMutation(
    ({
      etaDateFrom,
      etaDateTo,
      orderDateFrom,
      orderDateTo,
      receiptedDateFrom,
      receiptedDateTo,
      search,
      skip,
      status,
      take,
      warehouse,
    }: GetInboundShipmentListInterface) => {
      return postAPI(`/StockOrder`, {
        take,
        skip,
        searchKeyword: search === '' ? null : search,
        warehouse: warehouse === 'All' ? null : warehouse,
        status: status === 'All' ? null : status,
        stockOrderIds: null,
        orderDateFrom: orderDateFrom || null,
        orderDateTo: orderDateTo || null,
        receiptedDateFrom: receiptedDateFrom || null,
        receiptedDateTo: receiptedDateTo || null,
        etaDateFrom: etaDateFrom || null,
        etaDateTo: etaDateTo || null,
      })
    },
  )

  return mutate
}

export default useGetInboundShipmentList
